import { render } from "./SetStabilizationForm.vue?vue&type=template&id=c1bafcb8&scoped=true"
import script from "./SetStabilizationForm.vue?vue&type=script&lang=js"
export * from "./SetStabilizationForm.vue?vue&type=script&lang=js"

import "@/assets/stationForm.css?vue&type=style&index=0&id=c1bafcb8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1bafcb8"]])

export default __exports__